import { render } from "./TrailerDetail.vue?vue&type=template&id=745cade8&scoped=true"
import script from "./TrailerDetail.vue?vue&type=script&lang=js"
export * from "./TrailerDetail.vue?vue&type=script&lang=js"

import "./TrailerDetail.vue?vue&type=style&index=0&id=745cade8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745cade8"]])

export default __exports__